export default "/images/vendor/flag-icon-css/flags/4x3/bd.svg?d16830cba55e113c58881a5a7cb6a7cb";